import Vue from 'vue';
import Vuebar from 'vuebar';
import VueDragscroll from 'vue-dragscroll';
import VueSelect from 'vue-multiselect';
import device from 'current-device';
import VTooltip from 'v-tooltip';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.use(VTooltip);
Vue.use(device);
Vue.use(VueDragscroll);

Vue.use(Vuebar);


Vue.component('v-select', VueSelect);
